var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "directappointment"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-2",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.displayMsg == 'success') ? _c('b-alert', {
    staticClass: "success-display-none",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.displayMsg == 'error') ? _c('b-alert', {
    staticClass: "danger-display-none",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapseDirectAppt",
      modifiers: {
        "collapseDirectAppt": true
      }
    }],
    staticClass: " fa fa-filter filter",
    staticStyle: {
      "color": "#20a8d8",
      "float": "left"
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapseDirectAppt"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-users'></i>"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.clientData,
      "selected-options": _vm.selectedClientOptions,
      "placeholder": "Search Client",
      "hide-selected-options": false
    },
    on: {
      "select": _vm.selectedClientData
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Reference ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Reference ID"
    },
    model: {
      value: (_vm.filterReferenceId),
      callback: function($$v) {
        _vm.filterReferenceId = $$v
      },
      expression: "filterReferenceId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-info-circle'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.statusData,
      "selected-option": _vm.selectedStatusObj,
      "placeholder": "Select Status"
    },
    on: {
      "select": _vm.selectedStatusData
    },
    model: {
      value: (_vm.filterStatus),
      callback: function($$v) {
        _vm.filterStatus = $$v
      },
      expression: "filterStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Tagged By")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.taggedByData,
      "selected-option": _vm.selectedTaggedByObj,
      "placeholder": "Select Tagged By"
    },
    on: {
      "select": _vm.selectedTaggedByData
    },
    model: {
      value: (_vm.filterTaggedBy),
      callback: function($$v) {
        _vm.filterTaggedBy = $$v
      },
      expression: "filterTaggedBy"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("PickUp From Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.tillDate2,
      "not-after": _vm.toPickUpDate
    },
    on: {
      "change": _vm.onChangePickUpDate
    },
    model: {
      value: (_vm.fromPickUpDate),
      callback: function($$v) {
        _vm.fromPickUpDate = $$v
      },
      expression: "fromPickUpDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("PickUp To Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.fromPickUpDate,
      "not-after": _vm.tillDate1
    },
    on: {
      "change": _vm.onChangePickUpDate
    },
    model: {
      value: (_vm.toPickUpDate),
      callback: function($$v) {
        _vm.toPickUpDate = $$v
      },
      expression: "toPickUpDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Appointment From Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.tillDate2,
      "not-after": _vm.toAppointmentDeliveryDate
    },
    on: {
      "change": _vm.onChangeAppointmentDeliveryDate
    },
    model: {
      value: (_vm.fromAppointmentDeliveryDate),
      callback: function($$v) {
        _vm.fromAppointmentDeliveryDate = $$v
      },
      expression: "fromAppointmentDeliveryDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Appointment To Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.fromAppointmentDeliveryDate,
      "not-after": _vm.tillDate1
    },
    on: {
      "change": _vm.onChangeAppointmentDeliveryDate
    },
    model: {
      value: (_vm.toAppointmentDeliveryDate),
      callback: function($$v) {
        _vm.toAppointmentDeliveryDate = $$v
      },
      expression: "toAppointmentDeliveryDate"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Tagging From Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-after": _vm.toTaggingDate
    },
    model: {
      value: (_vm.fromTaggingDate),
      callback: function($$v) {
        _vm.fromTaggingDate = $$v
      },
      expression: "fromTaggingDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Tagging To Date :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.fromTaggingDate
    },
    model: {
      value: (_vm.toTaggingDate),
      callback: function($$v) {
        _vm.toTaggingDate = $$v
      },
      expression: "toTaggingDate"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Shipping ID's (AWB)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gift'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtShippingIDs),
      expression: "txtShippingIDs"
    }],
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "name": "txtShippingIDs",
      "rows": "3",
      "cols": "20"
    },
    domProps: {
      "value": (_vm.txtShippingIDs)
    },
    on: {
      "change": _vm.formatShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtShippingIDs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted w-100"
  }, [_vm._v("Upto 50 shipping IDs separated by comma")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "serachbtn1",
    staticStyle: {
      "padding-top": "5px",
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-left": "951px",
      "padding-right": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchButton
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])])]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn1",
    staticStyle: {
      "padding-top": "5px",
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-right": "5px",
      "padding-left": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  }), _vm._v("\n                        Clear")])])]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn1",
    staticStyle: {
      "padding-top": "5px",
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-right": "0px",
      "padding-left": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary cst_btn",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isExporting
    },
    on: {
      "click": function($event) {
        _vm.exportSearchResultsToCsv()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export")])])])])])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "alert alert-info directappointment-tagging-rule",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Tomorrow's appointment must be tagged before 7 PM.\n        "), (_vm.tomorrowTaggingRuleActive) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n          The 7 PM cutoff has passed — tomorrow's appointments cannot be tagged now.\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "margin-bottom": "2rem"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" B2B Appointment List :\n              "), _c('span', {
    staticClass: "badge",
    staticStyle: {
      "border-radius": "8px",
      "padding": "3px 8px",
      "background-color": "#f86c6b",
      "margin": "10px 5px 5px 10px"
    }
  }, [_vm._v(_vm._s(_vm.listTotalCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 cardlistheader",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary cst_btn",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadUploadTemplate()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openBulkUploadModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Bulk Upload\n            ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable tableFixHeadBottom"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.appointmentList), function(data, index) {
    return (_vm.appointmentList.length > 0) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.clientName || data.businessaccountname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.originBranch || data.originhubid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.destinationBranch || data.finaldestinationid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb || data.parentawb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mps || data.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDisplayDate(data.pickupslotsdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.consigneeName || data.consigneename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDisplayDate(data.appointmentdate || data.appointmentDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDisplayTime(data.dropslotsdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status || data.shipmentstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.referenceId || data.referenceid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.remark))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDisplayDate(data.createddate || data.appointmenttaggeddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.taggedBy || data.appointmenttaggedby))])]) : _vm._e()
  }), _vm._v(" "), (_vm.appointmentList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "14",
      "align": "center"
    }
  }, [_vm._v("Data not found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.pageCount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pageCount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "modal-class": "bulk-upload-modal",
      "content-class": "bulk-upload-modal__content",
      "no-enforce-focus": true,
      "hide-header": "",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: (_vm.uploadPreviewModal),
      callback: function($$v) {
        _vm.uploadPreviewModal = $$v
      },
      expression: "uploadPreviewModal"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-modal__container"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isUploading
    },
    on: {
      "update:active": function($event) {
        _vm.isUploading = $event
      }
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isSubmitting
    },
    on: {
      "update:active": function($event) {
        _vm.isSubmitting = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__header"
  }, [_c('div', {
    staticClass: "bulk-upload-modal__title-wrap"
  }, [_c('div', {
    staticClass: "bulk-upload-modal__icon"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "bulk-upload-modal__title"
  }, [_vm._v("Bulk Upload - B2B Appointment")]), _vm._v(" "), _c('p', {
    staticClass: "bulk-upload-modal__subtitle"
  }, [_vm._v("Upload a CSV or Excel file to add or update appointments in bulk")])])]), _vm._v(" "), _c('button', {
    staticClass: "bulk-upload-modal__close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeUploadPreviewModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__section"
  }, [_c('div', {
    staticClass: "bulk-upload-modal__upload-row"
  }, [_c('div', {
    staticClass: "bulk-upload-modal__file-panel"
  }, [_c('label', {
    staticClass: "bulk-upload-modal__file-label"
  }, [_c('input', {
    ref: "uploadFileInput",
    staticClass: "bulk-upload-modal__file-input",
    attrs: {
      "type": "file",
      "accept": ".csv,.xls,.xlsx"
    },
    on: {
      "change": _vm.handleUploadFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__file-box"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o bulk-upload-modal__file-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__file-name"
  }, [_vm._v(_vm._s(_vm.uploadFileName || 'Choose CSV or Excel file'))]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__file-hint"
  }, [_vm._v("Click to browse or drag and drop")])])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__requirements"
  }, [_c('span', {
    staticClass: "bulk-upload-modal__requirements-label"
  }, [_vm._v("Required columns")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__requirements-value"
  }, [_vm._v("AWB | Appointment Date")])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__requirements"
  }, [_c('span', {
    staticClass: "bulk-upload-modal__requirements-label"
  }, [_vm._v("Optional columns")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__requirements-value"
  }, [_vm._v("Time (Slot) e.g. 10:20:00 | Reference ID | Remark")])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__requirements"
  }, [_c('span', {
    staticClass: "bulk-upload-modal__requirements-label"
  }, [_vm._v("Tagging rule")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__requirements-value"
  }, [_vm._v("Tomorrow's appointment must be tagged before 7 PM")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary bulk-upload-modal__validate-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isUploading || !_vm.uploadFile
    },
    on: {
      "click": function($event) {
        _vm.validateUploadFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Validate File\n          ")])])]), _vm._v(" "), (_vm.uploadFileName) ? _c('div', {
    staticClass: "bulk-upload-modal__stats"
  }, [_c('div', {
    staticClass: "bulk-upload-modal__stat bulk-upload-modal__stat--file"
  }, [_c('span', {
    staticClass: "bulk-upload-modal__stat-label"
  }, [_vm._v("Selected File")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__stat-value",
    attrs: {
      "title": _vm.uploadFileName
    }
  }, [_vm._v(_vm._s(_vm.uploadFileName))])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__stat bulk-upload-modal__stat--valid"
  }, [_c('span', {
    staticClass: "bulk-upload-modal__stat-label"
  }, [_vm._v("Valid Records")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__stat-value"
  }, [_vm._v(_vm._s(_vm.validUploadRecords.length))])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__stat bulk-upload-modal__stat--invalid"
  }, [_c('span', {
    staticClass: "bulk-upload-modal__stat-label"
  }, [_vm._v("Invalid Records")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__stat-value"
  }, [_vm._v(_vm._s(_vm.invalidUploadRecords.length))])])]) : _vm._e(), _vm._v(" "), (_vm.validUploadRecords.length || _vm.invalidUploadRecords.length) ? _c('div', {
    staticClass: "bulk-upload-modal__preview"
  }, [(_vm.validUploadRecords.length) ? _c('div', {
    staticClass: "bulk-upload-modal__preview-panel"
  }, [_c('div', {
    staticClass: "bulk-upload-modal__preview-header bulk-upload-modal__preview-header--valid"
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Valid Records (Preview)")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__preview-count"
  }, [_vm._v(_vm._s(_vm.validUploadRecords.length))])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__table-wrap"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm bulk-upload-modal__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Appointment Date")]), _vm._v(" "), _c('th', [_vm._v("Time (Slot)")]), _vm._v(" "), _c('th', [_vm._v("Reference ID")]), _vm._v(" "), _c('th', [_vm._v("Remark")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.validUploadRecords), function(row, idx) {
    return _c('tr', {
      key: 'valid-' + idx
    }, [_c('td', [_vm._v(_vm._s(row.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.appointmentDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.appointmentTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.referenceId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.remark))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.invalidUploadRecords.length) ? _c('div', {
    staticClass: "bulk-upload-modal__preview-panel"
  }, [_c('div', {
    staticClass: "bulk-upload-modal__preview-header bulk-upload-modal__preview-header--invalid"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Invalid Records")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-upload-modal__preview-count"
  }, [_vm._v(_vm._s(_vm.invalidUploadRecords.length))])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__table-wrap"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm bulk-upload-modal__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Row")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Error")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invalidUploadRecords), function(row, idx) {
    return _c('tr', {
      key: 'invalid-' + idx
    }, [_c('td', [_vm._v(_vm._s(row.rowNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.awb))]), _vm._v(" "), _c('td', {
      staticClass: "bulk-upload-modal__error-cell"
    }, [_vm._v(_vm._s(row.errors))])])
  }))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-warning bulk-upload-modal__error-download",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadUploadErrorFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Download Error File\n          ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-modal__footer"
  }, [_c('button', {
    staticClass: "btn btn-light bulk-upload-modal__reset-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetUploadState()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Reset\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success bulk-upload-modal__submit-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.validUploadRecords.length || _vm.isSubmitting
    },
    on: {
      "click": function($event) {
        _vm.submitDirectAppointments()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Submit Appointment\n        ")])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "modal-class": "bulk-upload-result-modal",
      "content-class": "bulk-upload-result-modal__content",
      "no-enforce-focus": true,
      "hide-header": "",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: (_vm.submitResultModal),
      callback: function($$v) {
        _vm.submitResultModal = $$v
      },
      expression: "submitResultModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitResultModal),
      expression: "submitResultModal"
    }],
    staticClass: "bulk-upload-result-modal__container"
  }, [_c('div', {
    staticClass: "bulk-upload-result-modal__header"
  }, [_c('h5', {
    staticClass: "bulk-upload-result-modal__title"
  }, [_vm._v("Submission Result")]), _vm._v(" "), _c('button', {
    staticClass: "bulk-upload-result-modal__close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeSubmitResultModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-result-modal__body"
  }, [_c('p', {
    staticClass: "bulk-upload-result-modal__message"
  }, [_vm._v(_vm._s(_vm.submitResultMsg))]), _vm._v(" "), (_vm.submitFailedRecords.length) ? _c('button', {
    staticClass: "btn btn-outline-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadSubmitErrorFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Download Failed Records\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulk-upload-result-modal__footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeSubmitResultModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Close\n        ")])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('p', [_vm._v("B2B Appointment Search")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin Branch")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination Branch")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("AWB")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("MPS")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("PDD")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Consignee Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Appointment Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Appointment Time (Slot)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reference ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Remark")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Tagging Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Tagged By")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39654386","hasScoped":true}!./src/views/components/cargoappointment/cargoappointment.component.html
// module id = 938
// module chunks = 1